import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_FORM_PDF_REQUEST = 'GET_FORM_PDF_REQUEST';
export const GET_FORM_PDF_SUCCESS = 'GET_FORM_PDF_SUCCESS';
export const GET_FORM_PDF_FAILURE = 'GET_FORM_PDF_FAILURE';

function requestGetFormPdf() {
  return {
    type: GET_FORM_PDF_REQUEST,
    isFetchingPdfForm: true
  };
}

function receiveGetFormPdf(pdfData) {
  return {
    type: GET_FORM_PDF_SUCCESS,
    isFetchingPdfForm: false,
    pdfData,
    getFormPdfError: null
  };
}

function rejectGetFormPdf(getFormPdfError) {
  return {
    type: GET_FORM_PDF_FAILURE,
    isFetchingPdfForm: false,
    getFormPdfError
  };
}

export function getFormPdf(formId) {
  return (dispatch) => {
    dispatch(requestGetFormPdf());

    const promise = () => ApiService
      .getFormPdf(formId, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receiveGetFormPdf(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response) {
          const status = error.response && error.response.status;
          if (status !== 401) {
            dispatch(
              handleException(error, rejectGetFormPdf, !status || (status !== 404 && status !== 401))
            );
          }
        } else if (error.retries && error.retries > 1) {
          dispatch(
            handleException(error, rejectGetFormPdf, false)
          );
        }
      });
    return promise();
  };
}
